import { render, staticRenderFns } from "./ElementStyledText.vue?vue&type=template&id=bc40b74c&"
import script from "./ElementStyledText.vue?vue&type=script&lang=ts&"
export * from "./ElementStyledText.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStyledText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
